module.exports = __webpack_public_path__ + "images/application/illustrations/inbound-3d7a0450.svg";